import React from 'react';
import {Button} from 'reactstrap';
import './Btn.css'

const Btn = (props) => {
    return(
        <Button 
            onClick={props.onClick} 
            className={`${props.Secondary? "Secondary" : ""} ${props.Active? "active" : ""}`}
            style={props.style? props.style : {}}
            >
            <span style={props.txtStyle? props.txtStyle : {}}>
                {props.children}
            </span>
        </Button>
    )
} 
export default Btn;
export const BtnRow = (props) => {
    return(
        <div className={`
            btnRow
            ${props.Left? " left" : ""}
            ${props.Right? " right" : ""}
            ${props.Center? " center" : ""}
            ${props.flex? " d-flex" : ""}
        `
        }>
            {props.children}
        </div>
    )
} 

// const S = StyleSheet.create({
//     TCenter:{
//         textAlign: 'center'
//     },
//     TRight:{
//         textAlign: 'right'
//     },
//     TLeft:{
//         textAlign: 'left'
//     },
//     AlignLeft:{
//         alignSelf: 'flex-start'
//     },
//     AlignCenter:{
//         alignSelf: 'center'
//     },
//     AlignRight:{
//         alignSelf: 'flex-end'
//     },
//     Container:{
//         width: 150,
//         margin: 5,
//         paddingHorizontal: 10,
//         paddingVertical: 5,
//         borderRadius: 7,
//         shadowColor: "#000",
//         shadowOffset: {
//             width: 0,
//             height: 1,
//         },
//         shadowOpacity: 0.22,
//         shadowRadius: 2.22,

//         elevation: 3,
//     },
//     TextSize:{
//         fontSize:16
//     },
// });


// Readme:

// props=[
//     TCenter: TextAlign Center
//     TLeft: TextAlign Left
//     TRight: TextAlign Right
//     Primary: color Set to Primary Color and White Text
//     Secondary: color Set to Secondary Color and White Text
//     Right: Button align to Right
//     Left: Button align to Center
//     Center: Button align to Center
//     TextStyle: Customize Style for Text
//     BtnStyle: Customize Style for Button

// ]